module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/133.d584a840.png";